import type { CrmTag } from "@/lib/api/crm/masters";

export function TagList({ tags }: { tags: CrmTag[] }) {
  if (tags.length === 0) return null;
  return (
    <div className="mt-1.5 flex flex-wrap gap-1">
      {tags.map((tag) => (
        <span
          key={tag.id}
          className="inline-flex items-center rounded-md bg-white px-1.5 py-0.5 text-[11px] font-medium text-gray-600 ring-1 ring-inset ring-gray-200"
        >
          {tag.name}
        </span>
      ))}
    </div>
  );
}
